if (!customElements.get('tooltip-chips')) {
  class TooltipChips extends HTMLElement {
    constructor() {
      super();
      this.activeTooltip = null;
      this.clickHandler = this.handleClick.bind(this);
      this.outsideClickHandler = this.handleOutsideClick.bind(this);
      this.scrollHandler = this.handleScroll.bind(this);
      this.resizeHandler = this.handleResize.bind(this);
      this.compareTable = this.closest('compare-table');
    }

    // Static method to close all tooltips across all instances
    static closeAllTooltips() {
      const allTooltipChips = document.querySelectorAll('tooltip-chips');
      allTooltipChips.forEach(instance => {
        if (instance.activeTooltip) {
          instance.closeActiveTooltip();
        }
      });
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      // Add click event listener to the custom element
      this.addEventListener('click', this.clickHandler);
      
      // Add global click listener to handle outside clicks
      document.addEventListener('click', this.outsideClickHandler);
      
      // Add scroll and resize listeners to hide tooltips
      window.addEventListener('scroll', this.scrollHandler);
      window.addEventListener('resize', this.resizeHandler);
      this.compareTable.addEventListener('scroll', this.scrollHandler);
    }

    handleClick(event) {
      const clickedSpan = event.target.closest('span[data-chips]');

      if (!clickedSpan) return;

      event.preventDefault();
      event.stopPropagation();

      // Close all tooltips first (including from other instances)
      TooltipChips.closeAllTooltips();

      const chipsId = clickedSpan.getAttribute('data-chips');
      const chipsElement = this.querySelector(`#${chipsId}`);

      if (!chipsElement) {
        console.warn(`Chips element with ID "${chipsId}" not found`);
        return;
      }

      // Show the tooltip
      this.showTooltip(chipsElement, clickedSpan);
    }

    showTooltip(chipsElement, triggerElement) {
      // Show the tooltip
      chipsElement.classList.add('tooltip-chips--active');
      
      // Store reference to active tooltip
      this.activeTooltip = chipsElement;
      
      // Add active class to trigger element
      triggerElement.classList.add('tooltip-chips-trigger--active');
    }

    closeActiveTooltip() {
      if (this.activeTooltip) {
        this.activeTooltip.classList.remove('tooltip-chips--active');
        
        // Remove active class from trigger
        const activeTrigger = this.querySelector('.tooltip-chips-trigger--active');
        if (activeTrigger) {
          activeTrigger.classList.remove('tooltip-chips-trigger--active');
        }
        
        this.activeTooltip = null;
      }
    }

    handleOutsideClick(event) {
      // Close tooltip if clicking outside the tooltip-chips element
      if (!this.contains(event.target)) {
        this.closeActiveTooltip();
      }
    }

    handleScroll() {
      // Close tooltip on scroll
      this.closeActiveTooltip();
    }

    handleResize() {
      // Close tooltip on resize
      this.closeActiveTooltip();
    }

    disconnectedCallback() {
      // Clean up event listeners
      this.removeEventListener('click', this.clickHandler);
      document.removeEventListener('click', this.outsideClickHandler);
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  customElements.define('tooltip-chips', TooltipChips);
}
